'use client';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { useAppPersistenceStore } from '../store/useAppPersistenceStore';
// import { defaultNS } from './i18n.native';

const defaultLang = getLangFromCookie() ?? 'hi';

export const i18nOptions = {
  preload: ['hi'],
  fallbackLng: defaultLang,
  supportedLngs: ['bn', 'en', 'gu', 'hi', 'kn', 'ml', 'mr', 'or', 'pa', 'ta', 'te'],
  lng: defaultLang,
  defaultNS: 'translation',
  ns: ['translation'],
  debug: false,
  detection: {
    order: ['cookie', 'header'],
    caches: ['cookie'],
  },
  backend: { loadPath: `/locales/{{lng}}/{{ns}}.json` },
  interpolation: { escapeValue: false },
};
// console.log("🚀 ~ i18nOptions:", defaultLang, getLangFromCookie())

function getLangFromCookie(): string {
  if (typeof document === 'undefined') return 'hi';
  const match = document.cookie.match(/(?:^|; )lang=([^;]+)/);
  return match?.[1] ?? 'hi'; 
}

i18n.use(HttpApi).use(initReactI18next).init(i18nOptions);

export const changeLanguage = (str: string) => {
  // useAppPersistenceStore?.getState()?.setAppLanguage(str);
  return i18n.changeLanguage(str);
};

export default i18n;
